import React from "react";

import Footerhead from "../components/Footerhead";

import HeroSection from "../components/home/HeroSection";
import TrustedSection from "../components/home/TrustedSection";
import FinanceDepartmentSection from "../components/home/FinanceDepartmentSection";
import AIAccountingSection from "../components/home/AIAccountingSection";
import SecuritySection from "../components/home/SecuritySection";
import HowItWorksSection from "../components/home/HowItWorksSection";
import QualifiedAccountantsSection from "../components/home/QualifiedAccountantsSection";
import BetterServiceSection from "../components/home/BetterServiceSection";
import FooterCTACard from "../components/FooterCTACard";

const Home = () => {

  return (
    <>
      <HeroSection />

      <TrustedSection />

      <FinanceDepartmentSection />

      <AIAccountingSection />

      <HowItWorksSection />

      <QualifiedAccountantsSection />

      <SecuritySection />

      <BetterServiceSection />

      <FooterCTACard />

      <section className="container ">
        <Footerhead />
      </section>

    </>
  );
};

export default Home;
